<template>
  <div class="contactUs container has-text-left">
    <h1 class="title is-4 is-font-sans is-color-pff-light-blue">Contact Us</h1>
    <br />
    <div v-if="formSubmitted">
      <article class="message is-success">
        <div class="message-header">
          <p>Sent</p>
          <button class="delete" aria-label="delete" v-on:click="showForm"></button>
        </div>
        <div
          class="message-body"
        >Your message has been sent. Someone from the PFF Team will get in touch with you.</div>
      </article>
    </div>
    <form class="contactForm" @submit.prevent="submitContactForm" v-else>
      <div class="field">
        <label class="label is-color-grey">First Name</label>
        <div class="control">
          <input
            v-model="firstName"
            class="input"
            type="text"
            placeholder="Enter your first name"
            required
          />
        </div>
      </div>

      <div class="field">
        <label class="label is-color-grey">Last Name</label>
        <div class="control">
          <input
            v-model="lastName"
            class="input"
            type="text"
            placeholder="Enter your last name"
            required
          />
        </div>
      </div>

      <div class="field">
        <label class="label is-color-grey">Email</label>
        <div class="control">
          <input
            v-model="email"
            class="input"
            type="email"
            placeholder="enter you email address"
            required
          />
        </div>
      </div>

      <div class="field">
        <label class="label is-color-grey">Message</label>
        <div class="control">
          <textarea
            v-model="message"
            class="textarea"
            placeholder="Please tell us why you are contact us"
            required
          ></textarea>
        </div>
      </div>

      <div class="field is-grouped">
        <router-link class="button is-font-sans is-color-pff-orange" to="/">CANCEL</router-link>
        <span class="padding-0-5"></span>
        <button
          class="button is-font-sans is-color-white is-background-color-pff-orange"
          id="shareResultButton"
        >SEND</button>
      </div>
    </form>
  </div>
</template>

<script>
import { db } from "../components/firebase.init";

export default {
  name: "ContactUs",

  data() {
    return {
      formSubmitted: false,
      firstName: "",
      lastName: "",
      email: "",
      message: ""
    };
  },

  methods: {
    showForm() {
      this.formSubmitted = false;
    },

    submitContactForm() {
      db.collection("contactRequests")
        .add({
          time: new Date(Date.now()),
          fromFirstName: this.firstName,
          fromLastName: this.lastName,
          fromEmail: this.email.toLowerCase(),
          message: this.message
        })
        .then(confirmation => {
          console.log("Contact Requested saved.");
          this.firstName = "";
          this.lastName = "";
          this.email = "";
          this.message = "";
          this.formSubmitted = true;
        })
        .catch(error => {
          alert(error);
          console.log(error);
        });
    }
  }
};
</script>

<style scoped>
.contactUs {
  text-align: center;
  padding: 7vh 2rem 5rem 2rem;
}

.contactForm {
  width: 30rem !important;
  max-width: 75vw !important;
}

.padding-0-5 {
  padding: 0.5rem;
}
</style>
